const t = {
  name: "Chain2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 9.23858 3.23858 7 6 7H11V9H6C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15H11V17H6C3.23858 17 1 14.7614 1 12Z" fill="currentColor"/>
<path d="M5 11H19V13H5V11Z" fill="currentColor"/>
<path d="M18 17C20.7614 17 23 14.7614 23 12C23 9.23858 20.7614 7 18 7H13V9L18 9C19.6569 9 21 10.3431 21 12C21 13.6569 19.6569 15 18 15L13 15V17L18 17Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Chain2
};
